import { appSlice } from 'reducers/app';

const appActions = appSlice.actions;

export default appActions;
